import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { XCircle, ArrowLeft, CreditCard } from 'lucide-react';

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-zinc-800 flex items-center justify-center p-4">
      <div className="bg-zinc-900 rounded-2xl p-8 border border-zinc-800 text-center max-w-md">
        <div className="w-20 h-20 bg-red-500/20 rounded-full flex items-center justify-center mx-auto mb-6">
          <XCircle className="w-10 h-10 text-red-500" />
        </div>
        <h1 className="text-3xl font-bold text-white mb-3">Payment Cancelled</h1>
        <p className="text-zinc-400 mb-8">
          Your payment was cancelled. No charges were made. You can try again anytime.
        </p>
        <div className="space-y-3">
          <Button onClick={() => navigate('/payment')} className="w-full bg-emerald-600 hover:bg-emerald-700">
            <CreditCard className="w-4 h-4 mr-2" /> Try Again
          </Button>
          <Button onClick={() => navigate('/')} variant="outline" className="w-full border-zinc-700 text-zinc-300 hover:bg-zinc-800">
            <ArrowLeft className="w-4 h-4 mr-2" /> Back to Home
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
